import React, { Component } from 'react'
import { UIButton, UIInput, UISelect } from './guiElements';


export default class UsersList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
      const { headers, entries, recoveryMailTexts = {} } = this.props;
    const captions = [];
    headers.map((el, idx) =>  {
        const key = "head-" + idx;
        let col = null;
        switch (el.caption.type) {
            case "label":
                col = <div key={key}>{el.caption.value}</div>;
                break;
            default:
                col = <div key={key}>{"unrecognized " + el.caption.type}</div>;
                break;
        };
        if (col) {
            captions.push(<div key={"panel-" + idx} className="entry-list-row-panel entry-list-row-header">{col}</div>);
        }
            
        return col;

    });

    
    let userEntries = entries.map((row) => {
        const cols = headers.map((el, idx) =>  {
            const key = "col-" + idx;
            const nm = el.generic.name;
            const user = row.user;
            const {type: elementType, fieldType, mandatory, options, btnSaveText, btnDeleteText} = el.element;
            let col = null;
            let val = null;
            switch (elementType) {
                case "input":
                    col = <UIInput 
                        key={key}
                        type={fieldType}
                        name={nm}
                        value={user[nm]}
                        mandatory={mandatory}
                        className="users-list-inputs"
                        onChange={(ev) => el.generic.change(ev, nm, ev.currentTarget.value, user.id)} />;
                    break;
                case "select":
                    val = user.profileType
                    col = <UISelect
                        className="select-bold"
                         key={key} 
                         name={nm}
                         options={options}
                         value={val}
                         onChange={(ev) => el.generic.change(ev, nm, ev.currentTarget.value, user.id)} />;
                    break;
                case "recoveryMail":
                    col = (
                        <div className="recovery-mail-admin">
                            <div>
                                {user.maskedRecoveryMail || "-"}
                            </div>

                            <small
                                className={
                                    "recovery-status " +
                                    (user.recoveryMailStatus || "notConfigured")
                                }
                            >
                                {
                                    user.recoveryMailStatus === "verified"
                                        ? recoveryMailTexts.verified
                                        : user.recoveryMailStatus === "pending"
                                            ? recoveryMailTexts.pending
                                            : recoveryMailTexts.notConfigured
                                }
                            </small>
                        </div>
                    );
                    break;
                case "button": 
                    col = <div className='button-pad no-wrap'>
                        <UIButton className='modify' text={btnSaveText}  onClick={() => el.generic.click('modify', user.id)}/>
                        <UIButton className='modify delete' text={btnDeleteText} onClick={() => el.generic.click('delete', user.id)}  />
                    </div>;
                    break;
                default:
                    col = <div key={key}>{"unrecognized " + el.caption.type}</div>;
                    break;
            };
            return col ? <div className="entry-list-row-panel" key={"panel-" + idx}>{col}</div> : null;
        });
        return cols;
    }, this);

    let style = 'auto '.repeat(Math.max(0, captions.length - 1)) + 'min-content';


    return (
        <div className="report-table">
        <div key="rep-1" className="entry-list"  style={{gridTemplateColumns: style}}>
            {captions}
            {userEntries}
        </div>
    </div>
    )
  }
}
